import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import * as ROUTER_PATH_TITLE from "../../constants/ROUTER_PATH_TITLE";

// Import your pages
import IndexPage from "../../pages/Index/Index";
import LandingPage from "../../pages/Landing/Landing";
import RegisterPage from "../../pages/Register/Register";
import LoginPage from "../../pages/Login/Login";
import ForgotPasswordPage from "../../pages/ForgotPassword/ForgotPassword";
import NewPasswordPage from "../../pages/NewPassword/NewPassword";
import WidgetsPage from "../../pages/Widgets/Widgets";
import LoginWithHashPage from "../../pages/LoginWithHash/LoginWithHash";
import MyFeedback from "../../pages/MyFeedback/MyFeedback";
import UserProfilePage from "../../pages/UserProfile/UserProfile";
import MyWalletPage from "../../pages/MyWallet/MyWallet";
import CampaignOffersPage from "../../pages/CampaignOffers/CampaignOffersPage";
import QrReaderPage from "../../pages/QrReader/QrReaderPage";
import OfferPaymentPage from "../../pages/OfferPayment/OfferPaymentPage";
import QrWriterPage from "../../pages/QrWriter/QrWriterPage";
import TripsPage from "../../pages/Trips/Trips";
import TimelineTripsPage from "../../pages/TimelineTrips/TimelineTrips";
import CreateTripPage from "../../pages/CreateUpdateTrip/CreateTrip";
import UpdateTripPage from "../../pages/CreateUpdateTrip/UpdateTrip";
import TripClonePage from "../../pages/TripClone/TripClone";
import TripPlanRedirect from "../../pages/TripPlanRedirect/TripPlanRedirect";
import TripPlanPage from "../../pages/TripPlan/TripPlan";
import TimelinePlanPage from "../../pages/TimelinePlan/TimelinePlanPage";
import NotFoundPage from "../../pages/NotFound/NotFound";
import CitySelectPage from "../../pages/CitySelectPage/CitySelectPage";
import CityInfoPage from "../../pages/CityInfoPage/CityInfoPage";
import VisaAuthRedirect from "../../pages/VisaAuthRedirect/VisaAuthRedirect";
import VisaAuth from "../../pages/VisaAuth/VisaAuth";
import PlaceInfoPage from "../../pages/PlaceInfo/PlaceInfo";
// import TourInfoPage from "../../pages/TourInfo/TourInfo";
import TravelCompanions from "../../pages/TravelCompanions/TravelCompanions";
import TravelGuidePage from "../../pages/TravelGuide/TravelGuide";
// import LocalExperiencesPage from "../../pages/LocalExperiences/LocalExperiences";
// import ToursandTicketsPage from "../../pages/ToursandTickets/ToursandTickets";
import DeleteUserPage from "../../pages/DeleteUser/DeleteUserPage";
import FeedbackPage from "../../pages/FeedbackPage/FeedbackPage";
// import MyBookingsPage from "../../pages/MyBookingsPage/MyBookingsPage";
import SocialLoginRedirect from "../../pages/SocialLoginRedirect/SocialLoginRedirect";

// Import PrivateRoute for protecting routes
import PrivateRoute from "./PrivateRoute/PrivateRoute";
import OverviewPage from "../../pages/Overview/Overview";
import UseTripUrlPage from "../../pages/UseTripUrl/UseTripUrl";
import FavoritesPage from "../../pages/FavoritesPage/FavoritesPage";
import SimplyCaribbean from "../../pages/SimplyCaribbean/SimplyCaribbean";
import StudyLanding from "../../pages/StudyLanding/StudyLanding";
import SocialLoginSignout from "../../pages/SocialLoginSignout/SocialLoginSignout";
import ValaiLanding from "../../pages/ValaiLanding/ValaiLanding";
import DiscoverPage from "../../pages/ValaiLanding/DiscoverPage";
import TripPlannerValai from "../../pages/ValaiLanding/TripPlanner";
import DiscoverDetailPage from "../../pages/ValaiLanding/DiscoverDetailPage";
import DetailPoiAndTour from "../../pages/ValaiLanding/DetailPoiAndTour";
import TourDetailPage from "../../pages/ValaiLanding/TourDetailPage";
import EditTimelineTrip from "../../pages/ValaiLanding/EditTimelineTrip";
import {TRIP_PLANNER_VALAI, EDIT_TIMELINE_TRIP} from "../../constants/ROUTER_PATH_TITLE";
import VisaLanding from "../../pages/VisaLanding/Landing";
import CanadaStrongLanding from "../../pages/CanadaStrongLanding/CanadaStrongLanding";
import ToursandTicketsPage from "../../pages/ToursandTickets/ToursandTickets";
import LocalExperiencesPage from "../../pages/LocalExperiences/LocalExperiences";
import TourInfoPage from "../../pages/TourInfo/TourInfo";

const componentsMap: Record<string, React.FC> = {
  SimplyCaribbean,
  StudyLanding,
  ValaiLanding,
  VisaLanding,
  CanadaStrongLanding,
};
const LandingWrapper = () => {
  // ?landing=<Name> lets us preview a tenant landing before its config is switched
  const previewLanding = new URLSearchParams(window.location.search).get(
    "landing"
  );
  const landingPage = previewLanding || window.tconfig.LANDING_PAGE;
  const Component = componentsMap[landingPage] || LandingPage;
  return <Component />;
};

const AppRouter = () => (
  <Router basename={window.tconfig.DOMAIN_ROUTER_BASE_NAME}>
    <Routes>
      <Route path={ROUTER_PATH_TITLE.INDEX.PATH} element={<IndexPage />} />
      <Route
        path={ROUTER_PATH_TITLE.LANDING.PATH}
        element={<LandingWrapper />}
      />
      <Route
        path={`${ROUTER_PATH_TITLE.LANDING.PATH}/:language`}
        element={<LandingWrapper />}
      />
      <Route
        path={ROUTER_PATH_TITLE.REGISTER.PATH}
        element={<RegisterPage />}
      />
      <Route path={ROUTER_PATH_TITLE.LOGIN.PATH} element={<LoginPage />} />
      <Route
        path={ROUTER_PATH_TITLE.FORGOT_PASSWORD.PATH}
        element={<ForgotPasswordPage />}
      />
      <Route
        path={`${ROUTER_PATH_TITLE.NEW_PASSWORD.PATH}/:hash`}
        element={<NewPasswordPage />}
      />
      <Route
        path={`${ROUTER_PATH_TITLE.WIDGETS.PATH}/:widgetName`}
        element={<WidgetsPage />}
      />
      <Route
        path={`${ROUTER_PATH_TITLE.LOGIN_WITH_HASH.PATH}/:hashParam`}
        element={<LoginWithHashPage />}
      />
      <Route path="/" element={<PrivateRoute element={<TripsPage />} />} />
      <Route
        path={ROUTER_PATH_TITLE.MY_FEEDBACK.PATH}
        element={<PrivateRoute element={<MyFeedback />} />}
      />
      <Route
        path={ROUTER_PATH_TITLE.USER_PROFILE.PATH}
        element={<PrivateRoute element={<UserProfilePage />} />}
      />
      <Route
        path={ROUTER_PATH_TITLE.MY_WALLET.PATH}
        element={<PrivateRoute element={<MyWalletPage />} />}
      />
      <Route
        path={`${ROUTER_PATH_TITLE.CAMPAIGN_OFFERS.PATH}/:campaignId`}
        element={<PrivateRoute element={<CampaignOffersPage />} />}
      />
      <Route
        path={ROUTER_PATH_TITLE.QR_READER.PATH}
        element={<PrivateRoute element={<QrReaderPage />} />}
      />
      <Route
        path={`${ROUTER_PATH_TITLE.OFFER_PAYMENT.PATH}/:offerId`}
        element={<PrivateRoute element={<OfferPaymentPage />} />}
      />
      <Route
        path={`${ROUTER_PATH_TITLE.QR_WRITER.PATH}/:offerId`}
        element={<PrivateRoute element={<QrWriterPage />} />}
      />
      <Route
        path={ROUTER_PATH_TITLE.TRIPS.PATH}
        element={<PrivateRoute element={<TripsPage />} />}
      />
      <Route
        path={ROUTER_PATH_TITLE.TIMELINE_TRIPS.PATH}
        element={<PrivateRoute element={<TimelineTripsPage />} />}
      />
      <Route
        path={ROUTER_PATH_TITLE.CREATE_TRIP.PATH}
        element={<PrivateRoute element={<CreateTripPage />} />}
      />
      <Route
        path={`${ROUTER_PATH_TITLE.UPDATE_TRIP.PATH}/:hashParam`}
        element={<PrivateRoute element={<UpdateTripPage />} />}
      />
      <Route
        path={`${ROUTER_PATH_TITLE.TRIP_CLONE.PATH}/:hashParam`}
        element={<PrivateRoute element={<TripClonePage />} />}
      />
      <Route
        path={`${ROUTER_PATH_TITLE.TRIP_PLAN.PATH}/:hashParam`}
        element={<TripPlanRedirect />}
      />
      <Route
        path={`${ROUTER_PATH_TITLE.TRIP_PLAN.PATH}/:hashParam/:dayIndex`}
        element={<TripPlanPage />}
      />
      {/* Timeline Plan Routes */}
      <Route
        path={`${ROUTER_PATH_TITLE.TIMELINE_PLAN.PATH}/:hashParam`}
        element={<TimelinePlanPage />}
      />
      <Route
        path={`${ROUTER_PATH_TITLE.TIMELINE_PLAN.PATH}/:hashParam/:dayIndex`}
        element={<TimelinePlanPage />}
      />
      <Route
        path={`${ROUTER_PATH_TITLE.TRAVEL_GUIDE.PATH}/:hash`}
        element={<PrivateRoute element={<TravelGuidePage />} />}
      />
      <Route
        path={`${ROUTER_PATH_TITLE.OVERVIEW.PATH}/:hash`}
        element={<PrivateRoute element={<OverviewPage />} />}
      />
      <Route
        path={ROUTER_PATH_TITLE.TRAVEL_COMPANIONS.PATH}
        element={<PrivateRoute element={<TravelCompanions />} />}
      />
      <Route
        path={ROUTER_PATH_TITLE.DELETE_USER.PATH}
        element={<PrivateRoute element={<DeleteUserPage />} />}
      />
      <Route
        path={ROUTER_PATH_TITLE.FEEDBACK_PAGE.PATH}
        element={<PrivateRoute element={<FeedbackPage />} />}
      />
      <Route
        path={ROUTER_PATH_TITLE.FAVORITES_PAGE.PATH}
        element={<PrivateRoute element={<FavoritesPage />} />}
      />
      {/* <Route path={ROUTER_PATH_TITLE.MY_BOOKINGS_PAGE.PATH} element={<PrivateRoute element={<MyBookingsPage />} />} /> */}
      <Route
        path={ROUTER_PATH_TITLE.CITY_INFO.PATH}
        element={<PrivateRoute element={<CitySelectPage />} />}
      />
      <Route
        path={`${ROUTER_PATH_TITLE.CITY_INFO.PATH}/:cityId`}
        element={<PrivateRoute element={<CityInfoPage />} />}
      />
       <Route
        path={ROUTER_PATH_TITLE.VISA_AUTH_REDIRECT.PATH}
        element={<PrivateRoute element={<VisaAuthRedirect />} />}
      />
      <Route
        path={ROUTER_PATH_TITLE.VISA_AUTH.PATH}
        element={<PrivateRoute element={<VisaAuth />} />}
      />
      <Route
        path={`${ROUTER_PATH_TITLE.PLACE_INFO.PATH}/:id`}
        element={<PlaceInfoPage />}
      />
      <Route path={`${ROUTER_PATH_TITLE.TOUR_INFO.PATH}/:providerId/:id`} element={<TourInfoPage />} />
      <Route path={ROUTER_PATH_TITLE.LOCAL_EXPERIENCES.PATH} element={<LocalExperiencesPage />} />
      <Route path={ROUTER_PATH_TITLE.TOURS_AND_TICKETS.PATH} element={<ToursandTicketsPage />}
      />
      <Route
        path={ROUTER_PATH_TITLE.USE_TRIP_URL.PATH}
        element={<UseTripUrlPage />}
      />
      <Route
        path={`${ROUTER_PATH_TITLE.SOCIAL_LOGIN_REDIRECT.PATH}`}
        element={<SocialLoginRedirect />}
      />
      <Route
          path={`${ROUTER_PATH_TITLE.SOCIAL_LOGIN_SIGNOUT.PATH}`}
          element={<SocialLoginSignout />}
      />
      {/*HCN ROUTES*/}
      <Route
          path={`${ROUTER_PATH_TITLE.DISCOVER_PAGE.PATH}`}
          element={<DiscoverPage />}
      />
      <Route
          path={`${ROUTER_PATH_TITLE.DISCOVER_PAGE.PATH}/:cityId`}
          element={<DiscoverDetailPage />}
      />
      <Route
          path={`${ROUTER_PATH_TITLE.DETAIL_POI_AND_TOUR.PATH}`}
          element={<DetailPoiAndTour />}
      />
      <Route
          path={`${ROUTER_PATH_TITLE.DETAIL_POI_AND_TOUR.PATH}/:cityId`}
          element={<DetailPoiAndTour />}
      />
      <Route
          path={`${ROUTER_PATH_TITLE.TRIP_PLANNER_VALAI.PATH}`}
          element={<TripPlannerValai />}
      />
      <Route
          path={`${EDIT_TIMELINE_TRIP.PATH}/:tripHash/:segmentIndex?`}
          element={<EditTimelineTrip />}
      />
      <Route
          path={`${ROUTER_PATH_TITLE.TOUR_DETAIL.PATH}`}
          element={<TourDetailPage />}
      />
      <Route
        path={ROUTER_PATH_TITLE.NOT_FOUND.PATH}
        element={<NotFoundPage />}
      />
    </Routes>
  </Router>
);

export default AppRouter;
